import { Grid, Link } from '@material-ui/core';
import React, { useCallback, useEffect } from 'react';
import { FormattedMessage, MessageDescriptor, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { REACT_APP_MONOLITH_BASE_URL } from 'runtimeEnvVars';

import {
  makeSelectEnforceBrandBasedPermissions,
  makeSelectPolicies,
} from 'containers/Auth_old/selectors';
import { addMessageAction } from 'containers/FlashMessage/actions';
import LeftArrow from 'images/arrow-left.svg';
import globalMessages from 'shared/global/messages';

import messages from './messages';
import { useStyles } from './styles';

interface BackToCompanySettingsProps {
  /**
   * What the link reads. Defaults to the bare "Back" every consumer has used
   * since this was extracted; pass a message that names the destination when a
   * design calls for one ("Back to settings"). The destination itself is not
   * configurable — it is always company settings, brands for a brand-scoped
   * user — so a label that names somewhere else would be a lie.
   */
  label?: MessageDescriptor;
}

export const BackToCompanySettings = ({
  label = globalMessages.back,
}: BackToCompanySettingsProps) => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const intl = useIntl();

  const { accountSlug } = useParams<{ accountSlug: string }>();

  const policies = useSelector(makeSelectPolicies());
  const { manage_account: manageAccount } = policies;

  const redirectUnauthorizedUser = useCallback(() => {
    history.push(`/${accountSlug}/openings`);
    dispatch(addMessageAction(intl.formatMessage(messages.noAccess), 'error'));
  }, [accountSlug, dispatch, history, intl]);

  useEffect(() => {
    if (!manageAccount) {
      redirectUnauthorizedUser();
    }
  }, [manageAccount, redirectUnauthorizedUser]);

  const enforceBrandBasedPermissions = useSelector(
    makeSelectEnforceBrandBasedPermissions(),
  );

  return (
    <Grid item className={styles.backToSettings}>
      <Link
        color="secondary"
        href={
          !manageAccount && enforceBrandBasedPermissions
            ? `${REACT_APP_MONOLITH_BASE_URL}/${accountSlug}/brands`
            : `${REACT_APP_MONOLITH_BASE_URL}/${accountSlug}/account/edit`
        }
      >
        <img src={LeftArrow} alt="back arrow" className={styles.leftArrow} />
        <FormattedMessage {...label} />
      </Link>
    </Grid>
  );
};
